$(document).ready(() => {
  // ========= Initialize GSAP & Lenis Scroll =========
  const initGsapAndLenis = () => {
    gsap.registerPlugin(ScrollTrigger);

    const lenis = new Lenis();

    lenis.on("scroll", () => {
      ScrollTrigger.update();
      // gsap.ticker.lagSmoothing(10);
    });

    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });

    // gsap.ticker.lagSmoothing(10);

    // Reset scroll position and refresh ScrollTrigger
    $(window).scrollTop(0);
    ScrollTrigger.refresh();
  };

  // ===CUSTOM QUICK ATC====
  const quickATC = () => {
    $(document).on("click", ".quickATCBtn", function () {
      const atcBtn = $(this);
      const variantId = atcBtn.data("variant-id");
      const quantity = Number(atcBtn.data("quantity")) || 1;

      if (!variantId || atcBtn.hasClass("disbaledBtn")) {
        return;
      }

      const loadingIcon = `<span class="button is-loading is-loading--icon-only"></span>`;
      const atcBtnTxt = atcBtn.html();
      atcBtn.empty().html(loadingIcon).addClass("disbaledBtn");

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          id: variantId,
          quantity: quantity,
        },
        dataType: "json",
        success: function (response) {
          console.log("Added to cart:", response);
          const finalizeQuickAtc = () => {
            if (typeof Shopify.theme.jsAjaxCart !== "undefined") {
              Shopify.theme.jsAjaxCart.updateView();
              Shopify.theme.jsAjaxCart.showDrawer();
            }
            atcBtn.empty().html(atcBtnTxt).removeClass("disbaledBtn");
          };

          if (
            window.APLThemeHelpers &&
            typeof window.APLThemeHelpers.syncFreeGiftCart === "function"
          ) {
            window.APLThemeHelpers.syncFreeGiftCart({
              showStatus: true,
            }).always(finalizeQuickAtc);
          } else {
            finalizeQuickAtc();
          }
        },
        error: function (xhr) {
          alert("Error adding to cart");
          console.error("Error adding to cart:", xhr.responseText);
          atcBtn.html(atcBtnTxt).removeClass("disbaledBtn");
        },
      });
    });
  };

  // ===COLLECTION TABS====
  const collectionTabs = () => {
    $(document).on("click", ".collectionTabsNavButton", function () {
      const currentTab = $(this);
      const currentSection = currentTab.closest(
        "[data-collection-tabs-section]",
      );
      const currentTabId = currentTab.data("tab-trigger");

      currentSection
        .find(".collectionTabsNavButton")
        .removeClass("is-active")
        .attr("aria-selected", "false");
      currentSection.find(".collectionTabsPanel").removeClass("is-active");

      currentTab.addClass("is-active").attr("aria-selected", "true");
      currentSection
        .find(`[data-tab-panel="${currentTabId}"]`)
        .addClass("is-active");
    });
  };

  // ===CUSTOM COLLECTION SORT====
  const customCollectionSort = () => {
    const buildDropdown = (currentWrap) => {
      const currentSelect = currentWrap.find("#sort-by");
      const currentLabel = currentWrap.find(
        "[data-custom-collection-sort-label]",
      );
      const currentDropdown = currentWrap.find(
        "[data-custom-collection-sort-dropdown]",
      );

      if (!currentSelect.length || !currentDropdown.length) {
        return;
      }

      const selectedOption = currentSelect.find("option:selected");
      currentLabel.text(selectedOption.text());
      currentDropdown.empty();

      currentSelect.find("option").each(function () {
        const currentOption = $(this);
        const optionValue = currentOption.attr("value");
        const optionLabel = currentOption.text();
        const isSelected = currentOption.is(":selected");
        const optionButton = $(`
          <button
            type="button"
            class="customCollectionSortOption${isSelected ? " is-active" : ""}"
            data-custom-collection-sort-option
            data-value="${optionValue}"
            role="option"
            aria-selected="${isSelected ? "true" : "false"}"
          >
            ${optionLabel}
          </button>
        `);

        currentDropdown.append(optionButton);
      });
    };

    $("[data-custom-collection-sort]").each(function () {
      buildDropdown($(this));
    });

    $(document).on(
      "click",
      "[data-custom-collection-sort-trigger]",
      function (event) {
        event.preventDefault();

        const currentWrap = $(this).closest("[data-custom-collection-sort]");
        const isOpen = currentWrap.hasClass("is-open");

        $("[data-custom-collection-sort]").removeClass("is-open");
        $("[data-custom-collection-sort-trigger]").attr(
          "aria-expanded",
          "false",
        );
        $("[data-custom-collection-sort-dropdown]").attr("aria-hidden", "true");

        if (!isOpen) {
          currentWrap.addClass("is-open");
          currentWrap
            .find("[data-custom-collection-sort-trigger]")
            .attr("aria-expanded", "true");
          currentWrap
            .find("[data-custom-collection-sort-dropdown]")
            .attr("aria-hidden", "false");
        }
      },
    );

    $(document).on(
      "click",
      "[data-custom-collection-sort-option]",
      function (event) {
        event.preventDefault();

        const currentOption = $(this);
        const currentWrap = currentOption.closest(
          "[data-custom-collection-sort]",
        );
        const currentSelect = currentWrap.find("#sort-by");
        const nextValue = currentOption.data("value");

        if (!currentSelect.length || !nextValue) {
          return;
        }

        currentSelect.val(nextValue).trigger("change");
        buildDropdown(currentWrap);
        currentWrap.removeClass("is-open");
        currentWrap
          .find("[data-custom-collection-sort-trigger]")
          .attr("aria-expanded", "false");
        currentWrap
          .find("[data-custom-collection-sort-dropdown]")
          .attr("aria-hidden", "true");
      },
    );

    $(document).on(
      "change",
      "[data-custom-collection-sort] #sort-by",
      function () {
        buildDropdown($(this).closest("[data-custom-collection-sort]"));
      },
    );

    $(document).on("click", function (event) {
      if (!$(event.target).closest("[data-custom-collection-sort]").length) {
        $("[data-custom-collection-sort]").removeClass("is-open");
        $("[data-custom-collection-sort-trigger]").attr(
          "aria-expanded",
          "false",
        );
        $("[data-custom-collection-sort-dropdown]").attr("aria-hidden", "true");
      }
    });
  };

  // ===TESTIMONIAL SHOWCASE====
  const testimonialShowcase = () => {
    const pauseSectionVideos = ($section) => {
      $section.find("[data-testimonial-video]").each(function () {
        this.pause();
      });

      $section
        .find("[data-testimonial-video-toggle]")
        .removeClass("is-playing")
        .attr("aria-label", "Play testimonial video");
    };

    $("[data-testimonial-showcase-section]").each(function () {
      const currentSection = $(this);
      const currentCarousel = currentSection.find(
        "[data-testimonial-showcase-carousel]",
      );
      const currentDotsWrap = currentSection.find(
        "[data-testimonial-showcase-dots]",
      );
      const currentSlidesCount =
        Number(currentCarousel.data("testimonial-showcase-count")) || 0;

      if (
        !currentCarousel.length ||
        currentCarousel.hasClass("flickity-enabled")
      ) {
        return;
      }

      if (currentSlidesCount > 1 && typeof $.fn.flickity === "function") {
        const isMobile = window.matchMedia("(max-width: 798px)").matches;
        currentCarousel.flickity({
          wrapAround: true,
          prevNextButtons: false,
          pageDots: isMobile,
          adaptiveHeight: false,
          cellAlign: "left",
          contain: true,
          draggable: true,
        });

        if (isMobile && currentDotsWrap.length) {
          const pageDots = currentCarousel.find(".flickity-page-dots");

          if (pageDots.length) {
            currentDotsWrap.empty().append(pageDots);
          }
        }

        currentCarousel.on("change.flickity", function () {
          pauseSectionVideos(currentSection);
        });

        currentCarousel.on("settle.flickity", function () {
          currentCarousel.flickity("resize");
        });
      }
    });

    $(document).on("click", "[data-testimonial-showcase-prev]", function () {
      const currentSection = $(this).closest(
        "[data-testimonial-showcase-section]",
      );
      const currentCarousel = currentSection.find(
        "[data-testimonial-showcase-carousel]",
      );

      if (
        typeof $.fn.flickity === "function" &&
        currentCarousel.hasClass("flickity-enabled")
      ) {
        currentCarousel.flickity("previous");
      }
    });

    $(document).on("click", "[data-testimonial-showcase-next]", function () {
      const currentSection = $(this).closest(
        "[data-testimonial-showcase-section]",
      );
      const currentCarousel = currentSection.find(
        "[data-testimonial-showcase-carousel]",
      );

      if (
        typeof $.fn.flickity === "function" &&
        currentCarousel.hasClass("flickity-enabled")
      ) {
        currentCarousel.flickity("next");
      }
    });

    $(document).on("click", "[data-testimonial-video-toggle]", function () {
      const currentButton = $(this);
      const currentSection = currentButton.closest(
        "[data-testimonial-showcase-section]",
      );
      const currentVideo = currentButton
        .closest("[data-testimonial-video-wrap]")
        .find("[data-testimonial-video]")
        .get(0);

      if (!currentVideo) {
        return;
      }

      if (currentVideo.paused) {
        pauseSectionVideos(currentSection);
        currentVideo.muted = false;
        currentVideo.volume = 1;
        currentVideo.play();
        currentButton
          .addClass("is-playing")
          .attr("aria-label", "Pause testimonial video");
      } else {
        currentVideo.pause();
        currentButton
          .removeClass("is-playing")
          .attr("aria-label", "Play testimonial video");
      }
    });
  };

  // ===MOVEMENT GALLERY====
  const movementGallery = () => {
    $("[data-movement-gallery-section]").each(function () {
      const currentSection = $(this);
      const currentCarousel = currentSection.find(
        "[data-movement-gallery-carousel]",
      );
      const carouselEnabled =
        String(currentSection.data("movement-gallery-carousel-enabled")) ===
        "true";

      if (
        !carouselEnabled ||
        !currentCarousel.length ||
        currentCarousel.hasClass("flickity-enabled") ||
        typeof $.fn.flickity !== "function"
      ) {
        return;
      }

      currentCarousel.flickity({
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        freeScroll: true,
        contain: false,
        groupCells: false,
        cellAlign: "left",
        draggable: true,
        autoPlay: 2600,
        pauseAutoPlayOnHover: false,
        selectedAttraction: 0.018,
        friction: 0.22,
      });

      currentCarousel.on("settle.flickity", function () {
        currentCarousel.flickity("resize");
      });
    });
  };

  // ===CUSTOM PADDLE STEPS====
  const customPaddleSteps = () => {
    const stepsArrowSvg = `
      <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <path d="M17.2765 6.91064L10.3658 13.8214L17.2765 20.7321" stroke="currentColor" stroke-width="1.72768" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;

    $("[data-custom-paddle-steps-section]").each(function () {
      const currentSection = $(this);
      const currentCarousel = currentSection.find(
        "[data-custom-paddle-steps-carousel]",
      );
      const currentDots = currentSection.find(
        "[data-custom-paddle-steps-dots]",
      );

      if (!currentCarousel.length || typeof $.fn.flickity !== "function") {
        return;
      }

      const setupCarousel = () => {
        const isMobile = window.matchMedia("(max-width: 640px)").matches;

        if (isMobile && !currentCarousel.hasClass("flickity-enabled")) {
          currentSection.addClass("is-mobile-carousel");
          currentCarousel.flickity({
            wrapAround: true,
            prevNextButtons: false,
            pageDots: true,
            contain: false,
            cellAlign: "left",
            draggable: true,
            groupCells: false,
            adaptiveHeight: true,
            imagesLoaded: true,
          });

          const pageDots = currentCarousel.find(".flickity-page-dots");

          if (pageDots.length && currentDots.length) {
            currentDots.empty().append(pageDots);
          }

          currentCarousel.find("img").on("load.customPaddleSteps", function () {
            currentCarousel.flickity("resize");
          });
        } else if (!isMobile && currentCarousel.hasClass("flickity-enabled")) {
          currentSection.removeClass("is-mobile-carousel");
          currentCarousel.find("img").off("load.customPaddleSteps");
          currentCarousel.flickity("destroy");

          if (currentDots.length) {
            currentDots.empty();
          }
        } else if (!isMobile) {
          currentSection.removeClass("is-mobile-carousel");
        }
      };

      setupCarousel();
      $(window)
        .off(`resize.customPaddleSteps-${currentSection.index()}`)
        .on(
          `resize.customPaddleSteps-${currentSection.index()}`,
          setupCarousel,
        );
    });

    $(document).on("click", "[data-custom-paddle-steps-prev]", function () {
      const currentCarousel = $(this)
        .closest("[data-custom-paddle-steps-section]")
        .find("[data-custom-paddle-steps-carousel]");

      if (
        typeof $.fn.flickity === "function" &&
        currentCarousel.hasClass("flickity-enabled")
      ) {
        currentCarousel.flickity("previous");
      }
    });

    $(document).on("click", "[data-custom-paddle-steps-next]", function () {
      const currentCarousel = $(this)
        .closest("[data-custom-paddle-steps-section]")
        .find("[data-custom-paddle-steps-carousel]");

      if (
        typeof $.fn.flickity === "function" &&
        currentCarousel.hasClass("flickity-enabled")
      ) {
        currentCarousel.flickity("next");
      }
    });

    $("[data-custom-paddle-steps-prev], [data-custom-paddle-steps-next]").each(
      function () {
        const currentButton = $(this);

        if (!currentButton.find("svg").length) {
          currentButton.html(stepsArrowSvg);
        }
      },
    );
  };

  // ===PRODUCT GALLERY CUSTOM UI====
  const productGalleryCustomUI = () => {
    const galleryArrowSvg = `
      <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <path d="M17.2765 6.91064L10.3658 13.8214L17.2765 20.7321" stroke="currentColor" stroke-width="1.72768" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;

    $(
      ".product-template .product-gallery__main .flickity-prev-next-button",
    ).each(function () {
      const currentButton = $(this);

      if (currentButton.find("svg").length) {
        currentButton.html(galleryArrowSvg);
      }
    });
  };

  // ===CUSTOM PADDLE CANVAS====
  const customPaddleCanvas = () => {
    const MAX_FILE_SIZE = 5 * 1024 * 1024;
    const frontImage = new Image();
    const backImage = new Image();
    const maskImage = new Image();
    const topLineMaskImage = new Image();
    const bottomLineMaskImage = new Image();
    const imageState = {
      front: null,
      back: null,
      topText: "",
      bottomText: "",
    };
    const textMaskBounds = {
      top: null,
      bottom: null,
    };
    const imageDebugSettings = {
      front: {
        offsetX: 0,
        offsetY: 12,
        widthAdjust: 33,
        heightAdjust: 0,
      },
      back: {
        offsetX: -24,
        offsetY: 6,
        widthAdjust: 33,
        heightAdjust: 0,
      },
    };
    const textDebugSettings = {
      top: {
        front: {
          offsetX: -50,
          offsetY: -59,
          widthAdjust: 0,
          heightAdjust: 0,
          fontSize: 46,
        },
        back: {
          offsetX: -169,
          offsetY: -59,
          widthAdjust: 0,
          heightAdjust: 0,
          fontSize: 46,
        },
      },
      bottom: {
        front: {
          offsetX: -53,
          offsetY: -77,
          widthAdjust: 0,
          heightAdjust: 0,
          fontSize: 24,
        },
        back: {
          offsetX: -172,
          offsetY: -77,
          widthAdjust: 0,
          heightAdjust: 0,
          fontSize: 24,
        },
      },
    };

    const drawIntoRegion = (ctx, sourceImage, region, settings = null) => {
      if (!sourceImage || !region) {
        return;
      }

      const resolvedRegion = settings
        ? {
            x: region.x + settings.offsetX / ctx.canvas.width,
            y: region.y + settings.offsetY / ctx.canvas.height,
            width: Math.max(
              0.02,
              region.width + settings.widthAdjust / ctx.canvas.width,
            ),
            height: Math.max(
              0.02,
              region.height + settings.heightAdjust / ctx.canvas.height,
            ),
          }
        : region;
      const targetWidth = ctx.canvas.width * resolvedRegion.width;
      const targetHeight = ctx.canvas.height * resolvedRegion.height;
      const targetX = ctx.canvas.width * resolvedRegion.x;
      const targetY = ctx.canvas.height * resolvedRegion.y;
      const imageRatio = sourceImage.width / sourceImage.height;
      const regionRatio = targetWidth / targetHeight;
      let drawWidth = targetWidth;
      let drawHeight = targetHeight;
      let drawX = targetX;
      let drawY = targetY;

      if (imageRatio > regionRatio) {
        drawHeight = targetHeight;
        drawWidth = drawHeight * imageRatio;
        drawX = targetX - (drawWidth - targetWidth) / 2;
      } else {
        drawWidth = targetWidth;
        drawHeight = drawWidth / imageRatio;
        drawY = targetY - (drawHeight - targetHeight) / 2;
      }

      ctx.drawImage(sourceImage, drawX, drawY, drawWidth, drawHeight);
    };

    const getMaskRegions = (maskAsset) => {
      if (!(maskAsset.complete && maskAsset.naturalWidth)) {
        return null;
      }

      const offCanvas = document.createElement("canvas");
      const width = maskAsset.naturalWidth;
      const height = maskAsset.naturalHeight;
      const midpoint = Math.floor(width / 2);
      const result = {
        left: null,
        right: null,
      };

      offCanvas.width = width;
      offCanvas.height = height;

      const offCtx = offCanvas.getContext("2d");
      offCtx.clearRect(0, 0, width, height);
      offCtx.drawImage(maskAsset, 0, 0, width, height);

      const { data } = offCtx.getImageData(0, 0, width, height);

      const scanSide = (xStart, xEnd) => {
        let minX = width;
        let minY = height;
        let maxX = 0;
        let maxY = 0;
        let hasPixel = false;

        for (let y = 0; y < height; y += 1) {
          for (let x = xStart; x < xEnd; x += 1) {
            const alphaIndex = y * width * 4 + x * 4 + 3;

            const red = data[alphaIndex - 3];
            const green = data[alphaIndex - 2];
            const blue = data[alphaIndex - 1];
            const brightness = (red + green + blue) / 3;

            if (data[alphaIndex] > 20 && brightness > 150) {
              hasPixel = true;
              minX = Math.min(minX, x);
              minY = Math.min(minY, y);
              maxX = Math.max(maxX, x);
              maxY = Math.max(maxY, y);
            }
          }
        }

        if (!hasPixel) {
          return null;
        }

        return {
          x: minX,
          y: minY,
          width: maxX - minX + 1,
          height: maxY - minY + 1,
        };
      };

      result.left = scanSide(0, midpoint);
      result.right = scanSide(midpoint, width);

      return result;
    };

    const fitFontSize = (
      ctx,
      textValue,
      maxWidth,
      maxHeight,
      fontFamily,
      weight,
      startingSize,
    ) => {
      let fontSize = startingSize;

      while (fontSize > 10) {
        ctx.font = `${weight} ${fontSize}px ${fontFamily}`;
        const metrics = ctx.measureText(textValue);
        const textHeight =
          (metrics.actualBoundingBoxAscent || fontSize * 0.8) +
          (metrics.actualBoundingBoxDescent || fontSize * 0.2);

        if (metrics.width <= maxWidth && textHeight <= maxHeight) {
          return fontSize;
        }

        fontSize -= 1;
      }

      return 10;
    };

    const getAdjustedRegion = (region, settings) => {
      if (!region) {
        return null;
      }

      return {
        x: region.x + settings.offsetX,
        y: region.y + settings.offsetY,
        width: Math.max(20, region.width + settings.widthAdjust),
        height: Math.max(12, region.height + settings.heightAdjust),
      };
    };

    const redrawAll = () => {
      $("[data-custom-paddle-stage]").each(function () {
        const stage = $(this);
        const canvas = stage.find("[data-custom-paddle-stage-canvas]").get(0);
        const mode = String(stage.data("custom-paddle-mode") || "image");

        if (!canvas) {
          return;
        }

        const ctx = canvas.getContext("2d");
        const width = canvas.width;
        const height = canvas.height;
        const frontRegion = {
          x: 0.084,
          y: 0.055,
          width: 0.315,
          height: 0.54,
        };
        const backRegion = {
          x: 0.6,
          y: 0.055,
          width: 0.315,
          height: 0.54,
        };

        ctx.clearRect(0, 0, width, height);

        if (mode === "text") {
          const drawMaskedTextLayer = (
            textValue,
            fillStyle,
            maskAsset,
            boundsKey,
            fontFamily,
            fontWeight,
            startingSize,
          ) => {
            const maskBounds = textMaskBounds[boundsKey];

            if (
              !textValue ||
              !(maskAsset.complete && maskAsset.naturalWidth) ||
              !maskBounds
            ) {
              return;
            }

            const tempCanvas = document.createElement("canvas");
            tempCanvas.width = width;
            tempCanvas.height = height;
            const tempCtx = tempCanvas.getContext("2d");
            const drawTextInRegion = (region, sideKey) => {
              const currentSettings = textDebugSettings[boundsKey][sideKey];
              const adjustedRegion = getAdjustedRegion(region, currentSettings);

              if (!adjustedRegion) {
                return;
              }

              const textToRender = String(textValue).trim();

              if (!textToRender) {
                return;
              }

              if (!region) {
                return;
              }

              const paddingX = 12;
              const paddingY = 4;
              const fontSize = fitFontSize(
                tempCtx,
                textToRender,
                Math.max(adjustedRegion.width - paddingX * 2, 40),
                Math.max(adjustedRegion.height - paddingY * 2, 12),
                fontFamily,
                fontWeight,
                currentSettings.fontSize || startingSize,
              );

              tempCtx.font = `${fontWeight} ${fontSize}px ${fontFamily}`;
              tempCtx.fillText(
                textToRender,
                adjustedRegion.x + adjustedRegion.width / 2,
                adjustedRegion.y + adjustedRegion.height / 2,
              );
            };

            tempCtx.clearRect(0, 0, width, height);
            tempCtx.fillStyle = fillStyle;
            tempCtx.textAlign = "center";
            tempCtx.textBaseline = "middle";
            drawTextInRegion(maskBounds.left, "front");
            drawTextInRegion(maskBounds.right, "back");
            ctx.drawImage(tempCanvas, 0, 0);
          };

          drawMaskedTextLayer(
            imageState.topText,
            "#111111",
            topLineMaskImage,
            "top",
            '"Times New Roman"',
            "700",
            46,
          );

          drawMaskedTextLayer(
            imageState.bottomText,
            "#111111",
            bottomLineMaskImage,
            "bottom",
            '"Helvetica Neue", Arial, sans-serif',
            "600",
            24,
          );
        } else {
          drawIntoRegion(
            ctx,
            imageState.front,
            frontRegion,
            imageDebugSettings.front,
          );
          drawIntoRegion(
            ctx,
            imageState.back,
            backRegion,
            imageDebugSettings.back,
          );

          if (maskImage.complete && maskImage.naturalWidth) {
            ctx.globalCompositeOperation = "destination-in";
            ctx.drawImage(maskImage, 0, 0, width, height);
            ctx.globalCompositeOperation = "source-over";
          }
        }
      });
    };

    const handleUpload = (file, side) => {
      if (!file || !side) {
        return;
      }

      const reader = new FileReader();
      const targetImage = side === "front" ? frontImage : backImage;

      reader.onload = function (event) {
        targetImage.onload = function () {
          imageState[side] = targetImage;
          redrawAll();
        };
        targetImage.src = event.target.result;
      };

      reader.readAsDataURL(file);
    };

    const showUploadToast = (message, type = "error") => {
      let toast = $(".aplCustomPaddleToast");

      if (!toast.length) {
        toast = $(
          '<div class="aplCustomPaddleToast" aria-live="polite"></div>',
        );
        $("body").append(toast);
      }

      toast.removeClass("is-visible is-error is-success");
      toast.text(message).addClass(`is-${type}`);

      window.clearTimeout(window.aplCustomPaddleToastTimer);

      requestAnimationFrame(() => {
        toast.addClass("is-visible");
      });

      window.aplCustomPaddleToastTimer = window.setTimeout(() => {
        toast.removeClass("is-visible");
      }, 3200);
    };

    const validateUploadFile = (file) => {
      return new Promise((resolve, reject) => {
        if (file.size > MAX_FILE_SIZE) {
          reject("Please upload an image below 5MB.");
          return;
        }

        resolve();
      });
    };

    $(document).on("change", "[data-custom-paddle-upload]", function () {
      const input = $(this);
      const side = input.data("custom-paddle-upload");
      const file = this.files && this.files[0] ? this.files[0] : null;
      const meta = $(`[data-custom-paddle-upload-meta="${side}"]`);
      const field = input.closest(".aplCustomPaddleUploadField");
      const preview = $(`[data-custom-paddle-upload-preview="${side}"]`);

      if (!file) {
        return;
      }

      validateUploadFile(file)
        .then(() => {
          meta.text(file.name);
          field.addClass("has-file");
          preview
            .empty()
            .append(
              `<img src="${URL.createObjectURL(file)}" alt="${side} upload preview">`,
            );
          handleUpload(file, side);
          showUploadToast(
            `${side === "front" ? "Front" : "Back"} image uploaded.`,
            "success",
          );
        })
        .catch((errorMessage) => {
          input.val("");
          field.removeClass("has-file");
          preview.empty();
          meta.text("PNG, JPG up to 5MB. Best size: 1080 x 1920 px.");
          showUploadToast(errorMessage, "error");
        });
    });

    $(document).on("input", "[data-custom-paddle-text-input]", function () {
      const input = $(this);
      const target = input.data("custom-paddle-text-input");

      if (target === "top") {
        imageState.topText = input.val();
      }

      if (target === "bottom") {
        imageState.bottomText = input.val();
      }

      redrawAll();
    });

    $(document).on(
      "click",
      "[data-custom-paddle-preview-trigger]",
      function () {
        const currentForm = $(this).closest("[data-product-form]");
        const currentGallery = currentForm
          .closest(".product_section")
          .find(".product-gallery__main");
        const currentStage = currentGallery
          .find("[data-custom-paddle-stage]")
          .first();
        const baseImage = currentStage
          .find(".aplCustomPaddleGalleryBaseImage")
          .get(0);
        const stageCanvas = currentStage
          .find("[data-custom-paddle-stage-canvas]")
          .get(0);
        const currentGalleryEl = currentGallery.get(0);
        const currentFlickity = currentGalleryEl
          ? window.Flickity.data(currentGalleryEl)
          : null;

        if (!baseImage || !stageCanvas) {
          return;
        }

        if (currentFlickity) {
          currentFlickity.select(0, false, true);
          currentFlickity.resize();
          currentGallery
            .find(".product-gallery__thumbnail")
            .removeClass("is-nav-selected")
            .eq(0)
            .addClass("is-nav-selected");
        }

        const previewCanvas = document.createElement("canvas");
        previewCanvas.width = stageCanvas.width;
        previewCanvas.height = stageCanvas.height;

        const previewCtx = previewCanvas.getContext("2d");
        previewCtx.drawImage(
          baseImage,
          0,
          0,
          previewCanvas.width,
          previewCanvas.height,
        );
        previewCtx.drawImage(
          stageCanvas,
          0,
          0,
          previewCanvas.width,
          previewCanvas.height,
        );

        const previewMarkup = `
        <div class="aplCustomPaddlePreviewPopup">
          <img src="${previewCanvas.toDataURL("image/png")}" alt="Custom paddle preview">
        </div>
      `;

        if ($.fancybox) {
          $.fancybox.open({
            src: previewMarkup,
            type: "html",
            touch: false,
            smallBtn: true,
          });
        }
      },
    );

    const firstForm = $("[data-product-form]").first();
    const hasCustomCover =
      String(firstForm.data("has-custom-cover")) === "true";

    if (hasCustomCover) {
      imageDebugSettings.front = {
        offsetX: -36,
        offsetY: 60,
        widthAdjust: 93,
        heightAdjust: 60,
      };
      imageDebugSettings.back = {
        offsetX: -63,
        offsetY: 87,
        widthAdjust: 93,
        heightAdjust: 60,
      };
    }

    const firstStage = $("[data-custom-paddle-stage]").first();
    const maskUrl = firstStage.data("custom-paddle-overlay");
    const topLineMaskUrl = firstStage.data("custom-paddle-top-line-mask");
    const bottomLineMaskUrl = firstStage.data("custom-paddle-bottom-line-mask");

    if (maskUrl) {
      maskImage.onload = function () {
        redrawAll();
      };
      maskImage.src = maskUrl;
    }

    if (topLineMaskUrl) {
      topLineMaskImage.onload = function () {
        textMaskBounds.top = getMaskRegions(topLineMaskImage);
        redrawAll();
      };
      topLineMaskImage.src = topLineMaskUrl;
    }

    if (bottomLineMaskUrl) {
      bottomLineMaskImage.onload = function () {
        textMaskBounds.bottom = getMaskRegions(bottomLineMaskImage);
        redrawAll();
      };
      bottomLineMaskImage.src = bottomLineMaskUrl;
    }

    redrawAll();
  };

  // ===PRODUCT TOP NOTICE CAROUSEL====
  const productTopNoticeCarousel = () => {
    const noticeArrowSvg = `
      <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <path d="M17.2765 6.91064L10.3658 13.8214L17.2765 20.7321" stroke="currentColor" stroke-width="1.72768" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;

    $("[data-product-top-notice-carousel]").each(function () {
      const currentCarousel = $(this);
      const slideCount =
        Number(currentCarousel.data("product-top-notice-count")) || 0;

      if (
        !currentCarousel.length ||
        currentCarousel.hasClass("flickity-enabled") ||
        typeof $.fn.flickity !== "function"
      ) {
        return;
      }

      if (slideCount <= 1) {
        currentCarousel
          .closest("[data-product-top-notice-wrap]")
          .addClass("is-single-slide");
        return;
      }

      currentCarousel.flickity({
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        adaptiveHeight: false,
        draggable: true,
        cellAlign: "center",
        contain: true,
        autoPlay: 4000,
        pauseAutoPlayOnHover: false,
      });
    });

    $(document).on("click", "[data-product-top-notice-prev]", function () {
      const currentCarousel = $(this)
        .closest("[data-product-top-notice-wrap]")
        .find("[data-product-top-notice-carousel]");

      if (
        typeof $.fn.flickity === "function" &&
        currentCarousel.hasClass("flickity-enabled")
      ) {
        currentCarousel.flickity("previous");
      }
    });

    $(document).on("click", "[data-product-top-notice-next]", function () {
      const currentCarousel = $(this)
        .closest("[data-product-top-notice-wrap]")
        .find("[data-product-top-notice-carousel]");

      if (
        typeof $.fn.flickity === "function" &&
        currentCarousel.hasClass("flickity-enabled")
      ) {
        currentCarousel.flickity("next");
      }
    });

    $("[data-product-top-notice-arrow]").each(function () {
      const currentButton = $(this);

      if (!currentButton.find("svg").length) {
        currentButton.html(noticeArrowSvg);
      }
    });
  };

  // ===PRODUCT PAGE CUSTOM UI====
  const productPageCustomUI = () => {
     $(document)
      .off("click.aplAccordionSync")
      .on("click.aplAccordionSync", ".aplProductAccordionTrigger", function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const currentTrigger = $(this);
        const currentItem = currentTrigger.closest(".aplProductAccordionItem");
        const currentContent = currentItem.find(".aplProductAccordionContent").first();
        const willOpen = !currentItem.hasClass("is-open");

        currentItem.toggleClass("is-open", willOpen);
        currentItem.toggleClass("tab--open", willOpen);

        if (willOpen) {
          currentContent.stop(true, true).slideDown(220);
        } else {
          currentContent.stop(true, true).slideUp(220);
        }
      });

    $(".aplProductAccordionItem").each(function () {
      const currentItem = $(this);
      const currentContent = currentItem.find(".aplProductAccordionContent").first();

      currentItem.removeClass("is-open tab--open");
      currentContent.stop(true, true).hide();
    });

    $("[data-product-addons-carousel]").each(function () {
      const currentCarousel = $(this);

      if (
        !currentCarousel.length ||
        currentCarousel.hasClass("flickity-enabled") ||
        typeof $.fn.flickity !== "function"
      ) {
        return;
      }

      currentCarousel.flickity({
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        contain: true,
        cellAlign: "left",
        draggable: true,
        groupCells: "100%",
      });

      currentCarousel.on("settle.flickity", function () {
        currentCarousel.flickity("resize");
      });
    });

    $(document).on("click", "[data-product-addons-prev]", function () {
      const currentCarousel = $(this)
        .closest(".aplProductAddOns")
        .find("[data-product-addons-carousel]");

      if (
        typeof $.fn.flickity === "function" &&
        currentCarousel.hasClass("flickity-enabled")
      ) {
        currentCarousel.flickity("previous");
      }
    });

    $(document).on("click", "[data-product-addons-next]", function () {
      const currentCarousel = $(this)
        .closest(".aplProductAddOns")
        .find("[data-product-addons-carousel]");

      if (
        typeof $.fn.flickity === "function" &&
        currentCarousel.hasClass("flickity-enabled")
      ) {
        currentCarousel.flickity("next");
      }
    });
  };

  // ===AUTOPLAY VIDEOS====
  const autoplaySectionVideos = () => {
    const playVideo = (videoElement) => {
      if (!videoElement) {
        return;
      }

      videoElement.muted = true;
      videoElement.defaultMuted = true;
      videoElement.setAttribute("muted", "muted");
      videoElement.setAttribute("playsinline", "playsinline");
      videoElement.setAttribute("autoplay", "autoplay");

      const playPromise = videoElement.play();

      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(() => {});
      }
    };

    $("[data-autoplay-video]").each(function () {
      const currentVideo = this;

      if (currentVideo.readyState >= 2) {
        playVideo(currentVideo);
      } else {
        currentVideo.addEventListener(
          "loadeddata",
          function handleLoadedData() {
            playVideo(currentVideo);
            currentVideo.removeEventListener("loadeddata", handleLoadedData);
          },
        );
      }
    });
  };

  // ===FREE GIFT CART SYNC====
  const syncFreeGiftCart = () => {
    const freeGiftVariantId = Number(window.aplTheme?.freeGiftVariantId) || 0;
    let isSyncing = false;
    let statusTimeout = null;

    const ensureStatusNode = () => {
      let statusNode = document.querySelector("[data-apl-free-gift-status]");

      if (!statusNode) {
        statusNode = document.createElement("div");
        statusNode.className = "aplFreeGiftStatus";
        statusNode.setAttribute("data-apl-free-gift-status", "");
        document.body.appendChild(statusNode);
      }

      return $(statusNode);
    };

    const showStatus = (message) => {
      const statusNode = ensureStatusNode();

      clearTimeout(statusTimeout);
      statusNode.text(message).addClass("is-visible");
    };

    const hideStatus = () => {
      const statusNode = ensureStatusNode();

      clearTimeout(statusTimeout);
      statusTimeout = window.setTimeout(() => {
        statusNode.removeClass("is-visible");
      }, 700);
    };

    const refreshCartPageMarkup = () => {
      if (!$(".cart__form").length) {
        return;
      }

      $.ajax({
        dataType: "html",
        cache: false,
        url: "/cart",
        success: function (html) {
          const updatedForm = $(html).find(".cart__form");
          const emptyMessage = $(html).find(".cart__empty-cart-message");

          if (updatedForm.length) {
            $(".cart__form").replaceWith(updatedForm);
          }

          if (emptyMessage.length) {
            $(".cart__empty-cart-message").replaceWith(emptyMessage);
          }
        },
      });
    };

    const refreshCartViews = () => {
      if (typeof Shopify.theme.jsAjaxCart !== "undefined") {
        Shopify.theme.jsAjaxCart.updateView();
      }

      refreshCartPageMarkup();
    };

    const runSync = (options = {}) => {
      const syncDeferred = $.Deferred();

      if (!freeGiftVariantId || isSyncing) {
        syncDeferred.resolve();
        return syncDeferred.promise();
      }

      isSyncing = true;

      $.getJSON("/cart.js")
        .done(function (cart) {
          const giftItems = cart.items.filter((item) => {
            const hasGiftProperty =
              item.properties && item.properties._apl_free_gift === "true";
            return (
              Number(item.variant_id) === freeGiftVariantId || hasGiftProperty
            );
          });
          const nonGiftItems = cart.items.filter((item) => {
            const hasGiftProperty =
              item.properties && item.properties._apl_free_gift === "true";
            return (
              Number(item.variant_id) !== freeGiftVariantId && !hasGiftProperty
            );
          });

          if (nonGiftItems.length === 0 && giftItems.length === 0) {
            syncDeferred.resolve(cart);
            return;
          }

          if (nonGiftItems.length === 0 && giftItems.length > 0) {
            const updates = {};

            giftItems.forEach((item) => {
              updates[item.key] = 0;
            });

            $.ajax({
              type: "POST",
              url: "/cart/update.js",
              data: JSON.stringify({ updates: updates }),
              contentType: "application/json; charset=UTF-8",
              dataType: "json",
              success: function () {
                refreshCartViews();
                syncDeferred.resolve();
              },
              error: function (xhr) {
                syncDeferred.reject(xhr);
              },
            });

            return;
          }

          if (giftItems.length === 0) {
            if (options.showStatus) {
              showStatus("Adding Free Product");
            }

            $.ajax({
              type: "POST",
              url: "/cart/add.js",
              data: JSON.stringify({
                id: freeGiftVariantId,
                quantity: 1,
                properties: {
                  _apl_free_gift: "true",
                },
              }),
              contentType: "application/json; charset=UTF-8",
              dataType: "json",
              success: function () {
                refreshCartViews();
                hideStatus();
                syncDeferred.resolve();
              },
              error: function (xhr) {
                hideStatus();
                syncDeferred.reject(xhr);
              },
            });

            return;
          }

          const updates = {};
          let hasUpdates = false;

          giftItems.forEach((item, index) => {
            const nextQuantity = index === 0 ? 1 : 0;

            if (Number(item.quantity) !== nextQuantity) {
              updates[item.key] = nextQuantity;
              hasUpdates = true;
            }
          });

          if (hasUpdates) {
            $.ajax({
              type: "POST",
              url: "/cart/update.js",
              data: JSON.stringify({ updates: updates }),
              contentType: "application/json; charset=UTF-8",
              dataType: "json",
              success: function () {
                refreshCartViews();
                syncDeferred.resolve();
              },
              error: function (xhr) {
                syncDeferred.reject(xhr);
              },
            });
          } else {
            syncDeferred.resolve(cart);
          }
        })
        .fail(function (xhr) {
          syncDeferred.reject(xhr);
        })
        .always(function () {
          isSyncing = false;
        });

      return syncDeferred.promise();
    };

    window.APLThemeHelpers = window.APLThemeHelpers || {};
    window.APLThemeHelpers.syncFreeGiftCart = runSync;

    if ($(".cart__form, [data-ajax-cart-content]").length) {
      runSync();
    }
  };

  // ===HOME PAGE SCROLL ANIMATIONS====
  const homePageScrollAnimations = () => {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
      return;
    }

    const revealHeader = (sectionSelector, targetsSelector) => {
      gsap.utils.toArray(sectionSelector).forEach((section) => {
        const targets = section.querySelectorAll(targetsSelector);

        if (!targets.length) {
          return;
        }

        gsap.set(targets, {
          opacity: 0,
          y: 28,
        });

        gsap.to(targets, {
          opacity: 1,
          y: 0,
          duration: 0.9,
          ease: "power3.out",
          stagger: 0.12,
          scrollTrigger: {
            trigger: section,
            start: "top 82%",
            once: true,
          },
        });
      });
    };

    const revealItems = (
      selector,
      triggerSelector = selector,
      start = "top 85%",
    ) => {
      gsap.utils.toArray(selector).forEach((item) => {
        const triggerItem = item.closest(triggerSelector) || item;

        gsap.set(item, {
          opacity: 0,
          y: 34,
        });

        gsap.to(item, {
          opacity: 1,
          y: 0,
          duration: 0.85,
          ease: "power3.out",
          scrollTrigger: {
            trigger: triggerItem,
            start: start,
            once: true,
          },
        });
      });
    };

    const parallaxMedia = (selector, triggerSelector) => {
      gsap.utils.toArray(selector).forEach((item) => {
        const triggerItem = item.closest(triggerSelector) || item;

        gsap.fromTo(
          item,
          {
            yPercent: -8,
            scale: 1.08,
          },
          {
            yPercent: 8,
            scale: 1,
            ease: "none",
            scrollTrigger: {
              trigger: triggerItem,
              start: "top bottom",
              end: "bottom top",
              scrub: 1.1,
            },
          },
        );
      });
    };

    revealHeader(
      ".featuredCollectionSection",
      ".featured-collection__preheading, .featured-collection__title",
    );
    revealHeader(
      ".collectionTabsSection",
      ".collectionTabsSectionTitle, .collectionTabsNav",
    );
    revealHeader(
      ".differenceMediaSection",
      ".differenceMediaSectionPreheading, .differenceMediaSectionTitle, .differenceMediaSectionBottomTitle",
    );
    revealHeader(
      ".testimonialShowcaseSection",
      ".testimonialShowcaseSectionPreheading, .testimonialShowcaseSectionTitle",
    );
    revealHeader(
      ".movementGallerySection",
      ".movementGallerySectionPreheading, .movementGallerySectionTitle, .movementGallerySectionDescription",
    );

    revealItems(".featuredCollectionProductCard");
    revealItems(
      ".collectionTabsPanel.is-active .featuredCollectionProductCard",
      ".collectionTabsSection",
    );
    revealItems(".differenceMediaSectionFeature", ".differenceMediaSection");
    revealItems(
      ".testimonialShowcaseCard",
      ".testimonialShowcaseSection",
      "top 80%",
    );
    revealItems(".movementGalleryItem", ".movementGallerySection", "top 88%");

    parallaxMedia(
      ".featuredCollectionProductCard .image__container.product__imageContainer img",
      ".featuredCollectionProductCard",
    );
    parallaxMedia(
      ".differenceMediaSectionStoryImageWrap img",
      ".differenceMediaSectionStoryCard",
    );
    parallaxMedia(
      ".differenceMediaSectionVideo",
      ".differenceMediaSectionVideoBox",
    );
    parallaxMedia(".testimonialShowcaseVideo", ".testimonialShowcaseVideoCard");
    parallaxMedia(
      ".testimonialShowcaseVideoPlaceholder img",
      ".testimonialShowcaseVideoCard",
    );
    parallaxMedia(".movementGalleryImageWrap img", ".movementGalleryItem");

    gsap.utils
      .toArray(
        ".differenceMediaSectionToast, .testimonialShowcaseToast, .floatingToastSection",
      )
      .forEach((item) => {
        gsap.fromTo(
          item,
          {
            y: 20,
          },
          {
            y: -8,
            ease: "none",
            scrollTrigger: {
              trigger: item,
              start: "top bottom",
              end: "bottom top",
              scrub: 1.4,
            },
          },
        );
      });
  };

  // ===PRODUCT PAGE SCROLL ANIMATIONS====
  const productPageScrollAnimations = () => {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
      return;
    }

    const revealItems = (
      selector,
      triggerSelector = selector,
      options = {},
    ) => {
      const start = options.start || "top 84%";
      const y = options.y || 28;
      const stagger = options.stagger || 0.08;

      gsap.utils.toArray(selector).forEach((item) => {
        const triggerItem = item.closest(triggerSelector) || item;

        gsap.set(item, {
          opacity: 0,
          y: y,
        });

        gsap.to(item, {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power3.out",
          stagger: stagger,
          scrollTrigger: {
            trigger: triggerItem,
            start: start,
            once: true,
          },
        });
      });
    };

    gsap.utils.toArray(".productTechSpecsSection").forEach((section) => {
      const header = section.querySelector(".productTechSpecsHeader");
      const items = section.querySelectorAll(".productTechSpecsItem");

      if (header) {
        gsap.set(header, { opacity: 0, y: 22 });
        gsap.to(header, {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power3.out",
          scrollTrigger: {
            trigger: section,
            start: "top 84%",
            once: true,
          },
        });
      }

      if (items.length) {
        gsap.set(items, { opacity: 0, y: 24, scale: 0.98 });
        gsap.to(items, {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.7,
          ease: "power3.out",
          stagger: 0.05,
          scrollTrigger: {
            trigger: section,
            start: "top 80%",
            once: true,
          },
        });
      }
    });

    gsap.utils.toArray(".productPpaMlpSection").forEach((section) => {
      const headingTargets = section.querySelectorAll(
        ".productPpaMlpPreheading, .productPpaMlpTitle",
      );
      const featureItems = section.querySelectorAll(".productPpaMlpFeature");
      const mediaBox = section.querySelector(".productPpaMlpVideoBox");

      if (headingTargets.length) {
        gsap.set(headingTargets, { opacity: 0, y: 24 });
        gsap.to(headingTargets, {
          opacity: 1,
          y: 0,
          duration: 0.85,
          ease: "power3.out",
          stagger: 0.1,
          scrollTrigger: {
            trigger: section,
            start: "top 84%",
            once: true,
          },
        });
      }

      if (featureItems.length) {
        gsap.set(featureItems, { opacity: 0, y: 22 });
        gsap.to(featureItems, {
          opacity: 1,
          y: 0,
          duration: 0.75,
          ease: "power3.out",
          stagger: 0.08,
          scrollTrigger: {
            trigger: section,
            start: "top 78%",
            once: true,
          },
        });
      }

      if (mediaBox) {
        gsap.set(mediaBox, { opacity: 0, x: 26, scale: 0.98 });
        gsap.to(mediaBox, {
          opacity: 1,
          x: 0,
          scale: 1,
          duration: 0.9,
          ease: "power3.out",
          scrollTrigger: {
            trigger: section,
            start: "top 80%",
            once: true,
          },
        });

        const mediaItem = mediaBox.querySelector(
          ".productPpaMlpVideo, .productPpaMlpFallbackImage",
        );

        if (mediaItem) {
          gsap.fromTo(
            mediaItem,
            {
              yPercent: -6,
              scale: 1.06,
            },
            {
              yPercent: 6,
              scale: 1,
              ease: "none",
              scrollTrigger: {
                trigger: mediaBox,
                start: "top bottom",
                end: "bottom top",
                scrub: 1.1,
              },
            },
          );
        }
      }
    });
  };

  // ===CUSTOM MOBILE MENU====
  const mobileMenu = () => {
    $(document).on("click", ".mobileMenuOpener", function () {
      $(".mobile-header").addClass("isOpen");
      $("body, html").addClass("hideScroll isMobileMenuOpen");
    });
    $(document).on("click", ".closeMenu", function () {
      $(".mobile-header").removeClass("isOpen");
      $("body, html").removeClass("hideScroll isMobileMenuOpen");
    });
  };

  // ===FOOTER / MOBILE LOCALIZATION CUSTOM DROPDOWN====
  const footerMobileCurrencyDropdown = () => {
    const dropdowns = document.querySelectorAll("[data-mobile-currency-dropdown]");

    if (!dropdowns.length) {
      return;
    }

    const closeAll = () => {
      dropdowns.forEach((dropdown) => {
        dropdown.classList.remove("is-open");
        const toggle = dropdown.querySelector("[data-mobile-currency-toggle]");
        if (toggle) {
          toggle.setAttribute("aria-expanded", "false");
        }
      });
    };

    dropdowns.forEach((dropdown) => {
      const toggle = dropdown.querySelector("[data-mobile-currency-toggle]");
      const options = dropdown.querySelectorAll("[data-mobile-currency-option]");
      const select = dropdown
        .closest(".selectors-form__currency--custom")
        ?.querySelector("select[data-disclosure-list]");

      if (!toggle || !select) {
        return;
      }

      toggle.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        const willOpen = !dropdown.classList.contains("is-open");
        closeAll();
        dropdown.classList.toggle("is-open", willOpen);
        toggle.setAttribute("aria-expanded", willOpen ? "true" : "false");
      });

      options.forEach((option) => {
        option.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          const value = option.getAttribute("data-value");
          if (!value) {
            return;
          }

          select.value = value;
          select.dispatchEvent(new Event("change", { bubbles: true }));

          options.forEach((item) => item.classList.remove("is-active"));
          option.classList.add("is-active");
          closeAll();
        });
      });
    });

    document.addEventListener("click", (event) => {
      if (!event.target.closest("[data-mobile-currency-dropdown]")) {
        closeAll();
      }
    });
  };

  // ===BUNDLE STRIPS====
  const toggleBundleCarousel = (
    section,
    carousel,
    options = {},
  ) => {
    const isMobile = window.matchMedia("(max-width: 798px)").matches;
    const enableDesktop =
      String(section.data("desktop-carousel")) === "true";
    const enableMobile =
      String(section.data("mobile-carousel")) === "true";
    const shouldEnable = isMobile ? enableMobile : enableDesktop;
    const isEnabled = carousel.hasClass("flickity-enabled");
    const dotsWrap = options.dotsWrap || $();
    const activeClass = options.activeClass || "is-carousel-active";
    const mobileClass = options.mobileClass || "is-mobile-carousel";
    const desktopClass = options.desktopClass || "is-desktop-carousel";

    section.removeClass(`${mobileClass} ${desktopClass}`);

    if (!shouldEnable) {
      if (isEnabled) {
        carousel.flickity("destroy");
      }
      dotsWrap.empty();
      section.removeClass(activeClass);
      return;
    }

    if (!isEnabled && typeof $.fn.flickity === "function") {
      carousel.flickity({
        wrapAround: false,
        prevNextButtons: false,
        pageDots: isMobile,
        adaptiveHeight: false,
        contain: true,
        cellAlign: "left",
        groupCells: false,
        draggable: true,
        imagesLoaded: true,
      });
    } else if (isEnabled) {
      carousel.flickity("resize");
    }

    section.addClass(activeClass);
    section.addClass(isMobile ? mobileClass : desktopClass);

    if (isMobile) {
      const pageDots = carousel.find(".flickity-page-dots");
      if (pageDots.length && dotsWrap.length) {
        dotsWrap.empty().append(pageDots);
      }
    } else {
      dotsWrap.empty();
    }
  };

  const bundleStrips = () => {
    const initCollectionStrips = () => {
      $("[data-collection-bundle-strip]").each(function () {
        const currentSection = $(this);
        const currentCarousel = currentSection.find(
          "[data-collection-bundle-carousel]",
        );
        const currentDotsWrap = currentSection.find(
          "[data-collection-bundle-dots]",
        );

        if (!currentCarousel.length) {
          return;
        }

        toggleBundleCarousel(currentSection, currentCarousel, {
          dotsWrap: currentDotsWrap,
        });
      });
    };

    const initProductStrips = () => {
      $("[data-product-bundle-strip]").each(function () {
        const currentSection = $(this);
        const currentCarousel = currentSection.find(
          "[data-product-bundle-carousel]",
        );
        const currentDotsWrap = currentSection.find("[data-product-bundle-dots]");

        if (!currentCarousel.length) {
          return;
        }

        toggleBundleCarousel(currentSection, currentCarousel, {
          dotsWrap: currentDotsWrap,
        });
      });
    };

    initCollectionStrips();
    initProductStrips();

    $(document).on("click", "[data-collection-bundle-prev]", function () {
      const currentCarousel = $(this)
        .closest("[data-collection-bundle-strip]")
        .find("[data-collection-bundle-carousel]");

      if (currentCarousel.hasClass("flickity-enabled")) {
        currentCarousel.flickity("previous");
      }
    });

    $(document).on("click", "[data-collection-bundle-next]", function () {
      const currentCarousel = $(this)
        .closest("[data-collection-bundle-strip]")
        .find("[data-collection-bundle-carousel]");

      if (currentCarousel.hasClass("flickity-enabled")) {
        currentCarousel.flickity("next");
      }
    });

    $(document).on("click", "[data-product-bundle-prev]", function () {
      const currentCarousel = $(this)
        .closest("[data-product-bundle-strip]")
        .find("[data-product-bundle-carousel]");

      if (currentCarousel.hasClass("flickity-enabled")) {
        currentCarousel.flickity("previous");
      }
    });

    $(document).on("click", "[data-product-bundle-next]", function () {
      const currentCarousel = $(this)
        .closest("[data-product-bundle-strip]")
        .find("[data-product-bundle-carousel]");

      if (currentCarousel.hasClass("flickity-enabled")) {
        currentCarousel.flickity("next");
      }
    });

    let bundleResizeTimer = null;
    $(window).on("resize", function () {
      window.clearTimeout(bundleResizeTimer);
      bundleResizeTimer = window.setTimeout(() => {
        initCollectionStrips();
        initProductStrips();
      }, 140);
    });
  };

  // ===ZEPTO PERSONALIZER THEME==== 
  const zeptoPersonalizerTheme = () => {
    const getPreviewSource = (button, localPreviewImage) => {
      const localSrc = localPreviewImage?.getAttribute("src") || "";

      if (localSrc) {
        return localSrc;
      }

      const previewImages = button.querySelectorAll(".img_url, .crop_img_url");

      for (const image of previewImages) {
        const src = image.getAttribute("src") || image.getAttribute("data-psrc") || "";
        if (src && !src.includes("blank.png")) {
          return src;
        }
      }

      return "";
    };

    const syncPreviewProperty = (button, localPreviewImage) => {
      const form = button.closest("form");
      const fileInput = button.querySelector('.fileupload[name^="properties["]');
      const dataName =
        fileInput?.getAttribute("data_name") ||
        button.querySelector(".img_url, .crop_img_url")?.getAttribute("data_name") ||
        "";

      if (!form || !dataName) {
        return;
      }

      const hiddenName = `properties[${dataName} Preview]`;
      let hiddenInput = Array.from(form.querySelectorAll('input[type="hidden"]')).find(
        (input) => input.name === hiddenName
      );

      if (!hiddenInput) {
        hiddenInput = document.createElement("input");
        hiddenInput.type = "hidden";
        hiddenInput.name = hiddenName;
        form.appendChild(hiddenInput);
      }

      hiddenInput.value = getPreviewSource(button, localPreviewImage);
    };

    const syncFileNameProperty = (button, fileInput) => {
      const form = button.closest("form");
      const dataName =
        fileInput?.getAttribute("data_name") ||
        button.querySelector(".img_url, .crop_img_url")?.getAttribute("data_name") ||
        "";

      if (!form || !dataName) {
        return;
      }

      const hiddenName = `properties[${dataName} File Name]`;
      let hiddenInput = Array.from(form.querySelectorAll('input[type="hidden"]')).find(
        (input) => input.name === hiddenName
      );

      if (!hiddenInput) {
        hiddenInput = document.createElement("input");
        hiddenInput.type = "hidden";
        hiddenInput.name = hiddenName;
        form.appendChild(hiddenInput);
      }

      hiddenInput.value = fileInput?.files?.[0]?.name || "";
    };

    const setupPersonalizer = (personalizer) => {
      if (!personalizer || personalizer.dataset.aplZeptoReady === "true") {
        return;
      }

      personalizer.dataset.aplZeptoReady = "true";

      const uploadButtons = personalizer.querySelectorAll(".pplrfileuploadbutton");

      uploadButtons.forEach((button) => {
        let localPreviewImage = button.querySelector(".aplZeptoUploadPreview");

        if (!localPreviewImage) {
          localPreviewImage = document.createElement("img");
          localPreviewImage.className = "aplZeptoUploadPreview";
          localPreviewImage.alt = "";
          button.appendChild(localPreviewImage);
        }

        const syncUploadState = () => {
          const previewImages = button.querySelectorAll(".img_url, .crop_img_url");
          let hasUploadedImage = Boolean(localPreviewImage.getAttribute("src"));
          let uploadedSrc = localPreviewImage.getAttribute("src") || "";

          previewImages.forEach((image) => {
            const src = image.getAttribute("src") || image.getAttribute("data-psrc") || "";
            if (src && !src.includes("blank.png")) {
              hasUploadedImage = true;
              uploadedSrc = src;
            }
          });

          if (uploadedSrc) {
            localPreviewImage.setAttribute("src", uploadedSrc);
            button.style.setProperty("--zepto-upload-preview", `url("${uploadedSrc}")`);
          }

          button.classList.toggle("has-uploaded-image", hasUploadedImage);
          syncPreviewProperty(button, localPreviewImage);
        };

        syncUploadState();

        const observer = new MutationObserver(syncUploadState);
        observer.observe(button, {
          subtree: true,
          attributes: true,
          attributeFilter: ["style", "src", "class", "data-psrc"],
        });

        const fileInput = button.querySelector(".fileupload");
        if (fileInput) {
          syncFileNameProperty(button, fileInput);

          fileInput.addEventListener("change", (event) => {
            const file = event.target.files && event.target.files[0];
            syncFileNameProperty(button, event.target);

            if (file) {
              const reader = new FileReader();
              reader.onload = (readerEvent) => {
                const dataUrl = readerEvent.target?.result;
                if (typeof dataUrl === "string" && dataUrl.length) {
                  localPreviewImage.setAttribute("src", dataUrl);
                  button.style.setProperty("--zepto-upload-preview", `url("${dataUrl}")`);
                  button.classList.add("has-uploaded-image");
                  syncPreviewProperty(button, localPreviewImage);
                }
              };
              reader.readAsDataURL(file);
            } else {
              localPreviewImage.removeAttribute("src");
              button.style.removeProperty("--zepto-upload-preview");
              button.classList.remove("has-uploaded-image");
              syncPreviewProperty(button, localPreviewImage);
            }

            window.setTimeout(syncUploadState, 250);
            window.setTimeout(syncUploadState, 900);
          });
        }
      });

      personalizer
        .querySelectorAll('.pplr_text[name^="properties["]:not(:disabled)')
        .forEach((field) => field.classList.add("aplZeptoTextField"));
    };

    const initPersonalizers = () => {
      const personalizers = document.querySelectorAll(".product-personalizer");
      if (!personalizers.length) {
        return false;
      }

      personalizers.forEach(setupPersonalizer);
      return true;
    };

    initPersonalizers();

    let attempts = 0;
    const personalizerInterval = window.setInterval(() => {
      attempts += 1;
      initPersonalizers();

      if (attempts >= 20) {
        window.clearInterval(personalizerInterval);
      }
    }, 500);
  };

  // ========= Calling Initialization Functions on Load =========
  initGsapAndLenis();
  quickATC();
  collectionTabs();
  customCollectionSort();
  testimonialShowcase();
  movementGallery();
  customPaddleSteps();
  productGalleryCustomUI();
  customPaddleCanvas();
  productTopNoticeCarousel();
  productPageCustomUI();
  syncFreeGiftCart();
  autoplaySectionVideos();
  homePageScrollAnimations();
  productPageScrollAnimations();
  mobileMenu();
  footerMobileCurrencyDropdown();
  bundleStrips();
  zeptoPersonalizerTheme();
  ScrollTrigger.refresh();
});
